module.exports = __webpack_public_path__ + "img/export.1bbb4fe9.svg";